import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/badge/badge.tsx
import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { Slot } from "@radix-ui/react-slot";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var Badge = forwardRef(
  (_a, ref) => {
    var _b = _a, { children, asChild, variant = "lighter", size = "small", className } = _b, rest = __objRest(_b, ["children", "asChild", "variant", "size", "className"]);
    const Component = asChild ? Slot : "span";
    return /* @__PURE__ */ jsx(
      Component,
      __spreadProps(__spreadValues({
        ref,
        className: clsx(
          "hds-badge",
          `hds-badge--${size}`,
          `hds-badge--${variant}`,
          className
        )
      }, rest), {
        children
      })
    );
  }
);
Badge.displayName = "Badge";

export {
  Badge
};
//# sourceMappingURL=chunk-OXZOGFNV.mjs.map